import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { JwtModule, JwtHelperService } from '@auth0/angular-jwt';
import { UsuarioInfoService } from "./usuario-info.service";
import { HttpClient, HttpHeaders, HttpRequest, HttpEventType, HttpErrorResponse } from "@angular/common/http";

import { throwError, Subscribable, Subscriber } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class ApiRequestService {

  constructor (
    private httpClient: HttpClient,
    private router:     Router,
    private usuarioInfoService: UsuarioInfoService
  ) {}

  /**
   * CONFIGURA O HEADER DE TODAS AS SOLICITAÇÕES ENVIADAS ADICINANDO TOKEN E OUTRAS INFORMAÇÕES NECESSARIAS
   * @param contentType string
   */
  addAuthHeader (contentType: string, parametros?: any) : HttpHeaders {
    let token = "";
    token = this.usuarioInfoService.getStoredToken();

    if (typeof parametros != 'undefined' && typeof parametros.token !== 'undefined' && parametros.token != null && parametros.token != '')      
        token = parametros.token;        

    const helper = new JwtHelperService();
    let infoToken = helper.decodeToken(token);
   
    let headers: HttpHeaders = new HttpHeaders();

    if (contentType !== 'upload' && contentType !== 'download') {
      headers = headers.append('Content-Type', contentType);
    }
    headers = headers.append('Authorization', 'Bearer ' + token);  

    if (typeof infoToken.idorg === 'undefined' || infoToken.idorg === null || infoToken.idorg === 310620000) {
      if (this.usuarioInfoService.getIdOrg() !== null && typeof this.usuarioInfoService.getIdOrg() !== 'undefined' && parseFloat(this.usuarioInfoService.getIdOrg()) !== 0) {    
        headers = headers.append('id_org', this.usuarioInfoService.getIdOrg().toString());
      }
    }

    if (typeof infoToken.idpes === 'undefined' || infoToken.idpes === null) {
      if (this.usuarioInfoService.getIdPes() !== null && typeof this.usuarioInfoService.getIdPes() !== 'undefined')
        headers = headers.append('id_pes', this.usuarioInfoService.getIdPes().toString());
    }

    if (typeof infoToken.idcgm === 'undefined' || infoToken.idcgm === null) {
      if (this.usuarioInfoService.getIdCgm() !== null && typeof this.usuarioInfoService.getIdCgm() !== 'undefined') {
        headers = headers.append('id_cgm', this.usuarioInfoService.getIdCgm().toString());        
      }
    }

    if (typeof infoToken.iddom === 'undefined' || infoToken.iddom === null || infoToken.iddom === 1) {
      if (this.usuarioInfoService.getIdDom() !== null && typeof this.usuarioInfoService.getIdDom() !== 'undefined') {
        headers = headers.append('id_dom', this.usuarioInfoService.getIdDom().toString());
      }
    }

    //INSERCAO DE SETOR NO HEADER
    if (typeof this.usuarioInfoService.getIdSet() !== 'undefined' && this.usuarioInfoService.getIdSet() != null) {
      if (parseInt(infoToken.idset) !== parseInt(this.usuarioInfoService.getIdSet())) {
        if (this.usuarioInfoService.getRoles().indexOf('ROLE_ADSI') >= 0 || this.usuarioInfoService.getRoles().indexOf('ROLE_ADMN') >= 0)
          headers = headers.append('id_set', this.usuarioInfoService.getIdSet().toString());
      }
    }

    //INSERCAO DE SECRETARIA NO TOKEN
    if (typeof this.usuarioInfoService.getIdSec() !== 'undefined' && this.usuarioInfoService.getIdSec() != null) {
      if (parseInt(infoToken.idsec) !== parseInt(this.usuarioInfoService.getIdSec())) {
        if (this.usuarioInfoService.getRoles().indexOf('ROLE_ADSI') >= 0 || this.usuarioInfoService.getRoles().indexOf('ROLE_ADMN') >= 0)
          headers = headers.append('id_sec', this.usuarioInfoService.getIdSec().toString());        
      }
    }

    //INSERCAO DE DEPARTAMENTO NO TOKEN
    if (typeof this.usuarioInfoService.getIdDep() !== 'undefined' && this.usuarioInfoService.getIdDep() != null) {
      if (parseInt(infoToken.iddep) !== parseInt(this.usuarioInfoService.getIdDep())) {
        if (this.usuarioInfoService.getRoles().indexOf('ROLE_ADSI') >= 0 || this.usuarioInfoService.getRoles().indexOf('ROLE_ADMN') >= 0)
          headers = headers.append('id_dep', this.usuarioInfoService.getIdDep().toString());        
      }
    }

    //INSERCAO DE CARGO NO TOKEN
    if (typeof this.usuarioInfoService.getIdCgo() !== 'undefined' && this.usuarioInfoService.getIdCgo() != null) {
      if (parseInt(infoToken.idcgo) !== parseInt(this.usuarioInfoService.getIdCgo())) {
        if (this.usuarioInfoService.getRoles().indexOf('ROLE_ADSI') >= 0 || this.usuarioInfoService.getRoles().indexOf('ROLE_ADMN') >= 0)
          headers = headers.append('id_cgo', this.usuarioInfoService.getIdCgo().toString());        
      }
    }

    //INSERCAO DE USUARIO NO TOKEN
    if (typeof this.usuarioInfoService.getIdUsu() !== 'undefined' && this.usuarioInfoService.getIdUsu() != null) {
      if (parseInt(infoToken.idusu) !== parseInt(this.usuarioInfoService.getIdUsu())) {
        if (this.usuarioInfoService.getRoles().indexOf('ROLE_ADSI') >= 0)
          headers = headers.append('id_usu', this.usuarioInfoService.getIdUsu().toString());        
      }
    }

    return headers;
  }

   /**
   * GET GENERICO PARA USO DE TODOS OS SERVIÇOS
   * @param url string
   * @param urlParams URLSearchParams
   */
  get (url: string, parametros?: any) : Observable<any> { 
    let contentType   = this.getContentType(parametros);
    let response: any = this.getResponseType(parametros);   

    return this.httpClient.get(this.codificaUrl(url), {
      headers:      this.addAuthHeader(contentType),
      responseType: response
    }).pipe(
      map ((resposta: any) => {
        if (typeof parametros !== 'undefined' && parametros.responseType === 'text') {
          JSON.stringify(resposta);
        }
       return resposta;
      }),
      catchError (error => {
        let header = this.addAuthHeader(contentType);
        let body = null;
        return throwError({error, url, body, header, 'method': 'GET' });
      })
    );    
  }

   /**
   * GET GENERICO PARA USO DE TODOS OS SERVIÇOS SINCRONOS
   * @param url string
   * @param urlParams URLSearchParams
   */
  async getAsync (url: string, parametros?: any) : Promise<any> { 
    try {
      let contentType   = this.getContentType(parametros);
      let response: any = this.getResponseType(parametros);

      let ret = await this.httpClient.get(this.codificaUrl(url), {
        headers: this.addAuthHeader(contentType),
        responseType: response
      }).toPromise();
      return ret as any;  
    } catch (error) {
      throw error;
    }
  }

   /**
   * GET GENERICO PARA USO DE TODOS OS SERVIÇOS COM ENVIO DE TOKEN
   * @param url string
   * @param urlParams URLSearchParams
   */
  getToken (url: string, token: string, parametros?: any) : Observable<any> { 
    let contentType   = this.getContentType(parametros);
    let response: any = this.getResponseType(parametros);    

    return this.httpClient.get(this.codificaUrl(url), {
      headers:      this.addAuthHeader(contentType, {'token': token}),
      responseType: response
    }).pipe (
      map((resposta: any) => {
        if (typeof parametros !== 'undefined' && parametros.responseType === 'text') {
          JSON.stringify(resposta);
        }
        return resposta;
      }),
      catchError ( error => {
        let header = this.addAuthHeader(contentType, {'token': token});
        let body = null;
        return throwError({error, url, body, header, 'method': 'GET' });
      })
    );    
  }
  
  post (url: string, body: Object, parametros?: any) : Observable<any> {
    let contentType   = this.getContentType(parametros);
    let response: any = this.getResponseType(parametros);

    return this.httpClient.post (this.codificaUrl(url), body, {
      headers:      this.addAuthHeader(contentType),
      responseType: response
    }).pipe(
      map ((resposta: any) => {
        if (typeof parametros !== 'undefined' && parametros.responseType === 'text') {
          JSON.stringify(resposta);
        }
       return resposta;
      }),
      catchError (error => {      
        let header = this.addAuthHeader(contentType);
        return throwError({error, url, body, header, 'method': 'POST' });
      })
    );    
  }

   /**
   * POST GENERICO PARA USO DE TODOS OS SERVIÇOS SINCRONOS
   * @param url string
   * @param urlParams URLSearchParams
   */
  async postAsync (url: string, body: Object, parametros?: any) : Promise<any> {
    try {
      let contentType   = this.getContentType(parametros);
      let response: any = this.getResponseType(parametros);

      let ret = await this.httpClient.post(this.codificaUrl(url), body, {
        headers: this.addAuthHeader(contentType),
        responseType: response
      }).toPromise();

      return ret as any; 
    } catch(error) {
      throw error;
    }
  }  

  /**
  * POST GENERICO PARA USO DE TODOS OS SERVIÇOS COM ENVIO DE TOKEN
  * @param url string
  * @param urlParams URLSearchParams
  */
  postToken (url: string, body: Object, token: string, parametros?: any) : Observable<any> { 
    let contentType   = this.getContentType(parametros);
    let response: any = this.getResponseType(parametros);

    return this.httpClient.post(this.codificaUrl(url), body, {
      headers:      this.addAuthHeader(contentType, {'token': token}),
      responseType: response
    }).pipe (
      map((resposta: any) => {
        if (typeof parametros !== 'undefined' && parametros.responseType === 'text') {
          JSON.stringify(resposta);
        }
        return resposta;
      }),
      catchError ( error => {
        let header = this.addAuthHeader(contentType, {'token': token});        
        return throwError({error, url, body, header, 'method': 'POST' });        
      })
    );    
  }

  /**
   * POST GENERICO PARA USO DE TODOS OS SERVIÇOS SINCRONOS
   * @param url string
   * @param urlParams URLSearchParams
   */
  async postTokenAsync(url: string, body: Object, token: string, parametros?: any) : Promise<any> {
    try {
      let contentType   = this.getContentType(parametros);
      let response: any = this.getResponseType(parametros);

      let ret = await this.httpClient.post(this.codificaUrl(url), body, {
        headers: this.addAuthHeader(contentType, {'token': token}),
        responseType: response
      }).toPromise();
      return ret as any;
    } catch(error) {
      throw error;
    }
  }

  /**
   * REALIZA O DOWNLOAD DE ARQUIVOS E ENVIA
   * O RETORNO COMPLETO DA SOLICITAÇÃO
   * INCLUINDO O HEADER COM A RESPOSTA DA SOLICITACAO
   */
  downloadFileHeaderResponse (url: string) {
    return this.httpClient.get(url, {      
      responseType: 'blob',
      headers: this.addAuthHeader('download'),
      observe: 'response'
    });    
  }

  downloadFile (url: string) : Observable<any> {
    return this.httpClient.get(this.codificaUrl(url), {
      headers: this.addAuthHeader('download'),
      responseType: "blob",
      reportProgress: true,
      observe: 'events'
    }).pipe(
      map ((retorno: any) => {
        if (retorno.type === HttpEventType.DownloadProgress) {
          let percent = Math.round(retorno.loaded / retorno.total * 100);
          return {'percent': percent, 'loaded': retorno.loaded, 'total': retorno.total}
        } else if (retorno.type === HttpEventType.Response && retorno.status == 200) {
          return retorno;
        }  
      }),
      catchError ( error => {   
       let header = this.addAuthHeader('download');
       let body = null;
       return throwError({error, url, body, header, 'method': 'DOWNLOAD' });
      })
    );
  }

  postUpload (url: string, file: File) : Observable<any> {  
    let formData = new FormData();    
    formData.append('file', file, file.name);
  
    return this.httpClient.post (this.codificaUrl(url), formData, {
        headers: this.addAuthHeader('upload'),
        reportProgress: true,
        observe: 'events'
      }).pipe (
        map ((event: any) => {
          if (event.type === HttpEventType.UploadProgress) {         
            return Math.round(event.loaded / event.total * 100);
          } else if (event.type === HttpEventType.Response) {
            return event;
          }  
        }),
        catchError (error => {          
          let header = this.addAuthHeader('upload');        
          return throwError({error, url, file, header, 'method': 'POST' });
        })
      );      
  }

  async postUploadAsync (url: string, file: File) : Promise<any[]> {
    try {
      let formData = new FormData();    
      formData.append('file', file, file.name);

      let response = await this.httpClient.post (this.codificaUrl(url), formData, {
        headers: this.addAuthHeader('upload'),
        reportProgress: true,
        observe: 'events'
      }).toPromise();
        return response as any;      
    } catch (error) {   
      throw error;      
    }
  }

  putUpload (url: string, file: File) : Observable<any> {  
    let formData = new FormData();    
    formData.append('file', file, file.name);
  
    return this.httpClient.put (this.codificaUrl(url), formData, {
        headers: this.addAuthHeader('upload'),
        reportProgress: true,
        observe: 'events'
      }).pipe(
        map ((event: any) => {
          if (event.type === HttpEventType.UploadProgress) {         
            return Math.round(event.loaded / event.total * 100);
          } else if (event.type === HttpEventType.Response) {
            return event;
          }  
        }),
        catchError (error => {          
          let header = this.addAuthHeader('upload');        
          return throwError({error, url, file, header, 'method': 'PUT' });
        })
      );      
  }

  async putUploadAsync (url: string, file: File) : Promise<any[]> {
    try {
      let formData = new FormData();    
      formData.append('file', file, file.name);

      let response = await this.httpClient.put (this.codificaUrl(url), formData, {
        headers: this.addAuthHeader('upload'),
        reportProgress: true,
        observe: 'events'
      }).toPromise();
        return response as any;      
    } catch (error) {
      let header = this.addAuthHeader('upload');
      await throwError({error, url, file, header, 'method': 'PUT' });
    }
  }

  put (url: string, body: Object, parametros?: any) : Observable<any> {
    let contentType   = this.getContentType(parametros);    
    let response: any = this.getResponseType(parametros);
    
    return this.httpClient.put (this.codificaUrl(url), body, {
      headers:      this.addAuthHeader(contentType),
      responseType: response
    }).pipe(
      map ((resposta: any) => {
        if (typeof parametros !== 'undefined' && parametros.responseType === 'text') {
          JSON.stringify(resposta);
        }
       return resposta;
      }),
      catchError (error => {        
        let header = this.addAuthHeader(contentType);        
        return throwError({error, url, body, header, 'method': 'PUT' });
      })
    );    
  }

  /**
   * PUT GENERICO PARA USO DE TODOS OS SERVIÇOS SINCRONOS
   * @param url string
   * @param urlParams URLSearchParams
   */
  async putAsync (url: string, body: Object, parametros?: any) : Promise<any> {
    try {
      let contentType   = this.getContentType(parametros);
      let response: any = this.getResponseType(parametros);

      let ret = await this.httpClient.put(this.codificaUrl(url), body, {
        headers: this.addAuthHeader(contentType),
        responseType: response
      }).toPromise();
      
      return ret as any;
    } catch(error) {
      throw error;
    }
  }  

  putToken (url: string, body: Object, token: string, parametros?: any) : Observable<any> {
    let contentType   = this.getContentType(parametros);    
    let response: any = this.getResponseType(parametros);
    
    return this.httpClient.put (this.codificaUrl(url), body, {
      headers:      this.addAuthHeader(contentType, {'token': token}),
      responseType: response
    }).pipe(
      map ((resposta: any) => {
        if (typeof parametros !== 'undefined' && parametros.responseType === 'text') {
          JSON.stringify(resposta);
        }
       return resposta;
      }),
      catchError (error => {
        let header = this.addAuthHeader(contentType, {'token': token});
        return throwError({error, url, body, header, 'method': 'PUT' });
      })
    );    
  }

  /**
   * PUT GENERICO PARA USO DE TODOS OS SERVIÇOS SINCRONOS
   * @param url string
   * @param urlParams URLSearchParams
   */
   async putTokenAsync(url: string, body: Object, token: string, parametros?: any) : Promise<any> {
    try {
      let contentType   = this.getContentType(parametros);
      let response: any = this.getResponseType(parametros);

      let ret = await this.httpClient.put(this.codificaUrl(url), body, {
        headers: this.addAuthHeader(contentType, {'token': token}),
        responseType: response
      }).toPromise();
      return ret as any;
    } catch(error) {
      throw error;
    }
  }  

  delete (url: string) : Observable<any> {       
    return this.httpClient.delete (this.codificaUrl(url), {
      headers: this.addAuthHeader('application/json'),
    }).pipe(
      map ((resposta => resposta)),
      catchError (error => {        
        let header = this.addAuthHeader('application/json');
        let body = null;
        return throwError({error, url, body, header, 'method': 'DELETE' });
      })
    );    
  }

  deleteToken (url: string, token: string) : Observable<any> {       
    return this.httpClient.delete (this.codificaUrl(url), {
      headers: this.addAuthHeader('application/json', {'token': token}),
    }).pipe(
      map ((resposta => resposta)),
      catchError (error => {        
        let header = this.addAuthHeader('application/json', {'token': token});
        let body = null;
        return throwError({error, url, body, header, 'method': 'DELETE' });
      })
    );    
  }

  /**
    * ENCAPSULA O HEADER E O CONTEUDO PARA ENVIAR A REQUISIÇÃO
    * @param requestMethod  RequestMethod
    * @param url string    
    * @param body Object    
    */
   getContentType(parametros: any) {
    let contentType = "application/json";
    if (typeof parametros !== 'undefined') {
      if (typeof parametros.contentType !== 'undefined') {
        switch (parametros.contentType) {
          case 'text':
            contentType = "text/plain";  
          break;
          case 'text/plain':
            contentType = "text/plain";  
          break;
          case 'uri-list':
            contentType = "text/uri-list";  
          break;
          case 'text/uri-list':
            contentType = "text/uri-list";  
          break;      
          default:
            contentType = "application/json";
          break;
        }
      }
    }  
    return contentType;
  }

  getResponseType (parametros: any) {
    let responseType = 'json';
    if (typeof parametros !== 'undefined') {
      if (typeof parametros.responseType !== 'undefined') {
        switch (parametros.responseType) {
          case 'text':
            responseType = 'text';  
          break;
          case 'array':
            responseType = 'arrayBuffer';
          break;
          case 'blob':
            responseType = 'blob';
          break;
          default:
            responseType = 'json';
          break;
        }
      }
    }
    return responseType;
  }

  /**
   * BUSCA OS DADOS DO ENDPOINT DE ACORDO COM PAGINA E TAMANHO SOLICITADOS
   * @param prefixo string
   * @param modelo  string (nome do modelo no backand ex: "pessoa")
   * @param pagina number
   * @param tamanho number (quantidade de itens por pagina)
   */
  listar (prefixo: string, modelo: string, pagina?: number, tamanho?: number) {
    let link: string = "";
      if (pagina != null) {
        link = "?page="+pagina;
      }
      if (pagina != null && tamanho != null) {
        link += "&size=" + tamanho;
      }
    return this.get(prefixo + "/" + modelo + link);
  }


  listarGenerico (url: string, pagina?: number, tamanho?: number) {
    let link: string = "";
    if (pagina != null) {
      link = "&page=" + pagina;
    }
    if (pagina != null && tamanho != null) {
      link += "&size=" + tamanho;
    }

    if(url.indexOf('?') < 0 && link.length > 0) {
      link = link.replace('&', '/?');
    }
    return this.get(url + link);
  }

  /**
   * Codifica os caracteres especiais mantendo a virgula para consultas com ENUM
   * alterando também codificação de []
   * @param url 
   */
  codificaUrl (url: string) : string {    
    //return encodeURI(url).replace(/%252C/g, ",").replace(/%255B/g, "%5B").replace(/%255D/g, "%5D");
    return url.replace('[', "%5B").replace(']', "%5D");
  }

}